import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconFlucs = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	viewBox: "0 0 100 100",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M98 20.2v25.3h-9.9V37L50.6 70.7 33.9 56.3 10.4 78.5c-1 .9-2.2 1.3-3.4 1.3-1.3 0-2.6-.5-3.6-1.5-1.9-2-1.8-5.1.2-7l30-28.4 16.8 14.6 30.4-27.4h-8.3v-9.9z"
	})
});
export { SvgIconFlucs as ReactComponent };
